<template>
    <section class="setting-profile-popup mfp-hide popup-save-document">
        <a @click="$router.go(-1)" class="profile-edit-close-btn">
            <img src="/assets/img/close-icon.svg"/>
        </a>
        <div class="setting-profile-wrapper">
            <div class="save-document-form">
                <h2>Log in Required</h2>
                <p>Please register or log in using the links below </p>
                <div style="display:block;">
                    <router-link :to="{ path: '/login' }" class="mx-auto">Log in</router-link>
                </div>

                <router-link :to="{ path: '/register' }" class="btn btn-outline-primary mr-0 mt-3 mx-auto">SIGN UP FREE</router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "RequireLoginMessage",
    mounted() {
        // console.log(this.$route.)
    }
}
</script>
